import { put, takeLatest } from 'redux-saga/effects'
import * as Eff from 'redux-saga/effects' // tslint:disable-line:no-duplicate-imports
import toastr from 'toastr'

import Logger from '@Utils/Logger'
import { IAction } from '@Root/types'

import {
  deleteProjectVersionsSuccess,
  deleteProjectVersionsFailure,
  updateProjectVersionTitleSuccess,
  updateProjectVersionTitleFailure,
} from './actions'

import {
  ProjectVersionActionTypes,
  IDeleteProjectVersionsPayload,
  IUpdateProjectVersionTitlePayload,
} from './types'

import * as API from './api'

const call: any = Eff.call

function* deleteProjectVersionsSaga(action: IAction<IDeleteProjectVersionsPayload>) {
  try {
    yield call(API.deleteProjectVersions, action.payload)
    yield put(deleteProjectVersionsSuccess(action.payload))
  } catch (e) {
    Logger.error(e, 'Clip(s) could not be deleted')
    yield put(deleteProjectVersionsFailure())
  }
}

function* updateProjectVersionTitleSaga(action: IAction<IUpdateProjectVersionTitlePayload>) {
  try {
    yield call(API.updateProjectVersionTitle, action.payload)
    yield put(updateProjectVersionTitleSuccess(action.payload))

    toastr.success('', 'Title changed')
  } catch (e) {
    Logger.error(e, 'Title could not be changed')
    yield put(updateProjectVersionTitleFailure())
  }
}

function* projectVersionSagas() {
  yield takeLatest(ProjectVersionActionTypes.DELETE_PROJECT_VERSIONS, deleteProjectVersionsSaga)
  yield takeLatest(ProjectVersionActionTypes.UPDATE_PROJECT_VERSION_TITLE, updateProjectVersionTitleSaga)
}

export default projectVersionSagas
